// src/data/gyms/Wicked.js
export const Wicked = {
  id: "wicked",
  name: "Wicked Extreme",
  color: "#4C1D95", // Deep Purple
  lightColor: "#F3E8FF",
  logo: "🌒",

  teams: [
    { id: "j2twilight", name: "J2 Twilight", level: "L2 Junior - Flex - D2" },
    { id: "j3revenge", name: "J3 Revenge", level: "L3 Junior - Flex - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "11:46 AM",
      teamId: "j3revenge",
      meet: "11:10 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:15 PM",
      teamId: "j2twilight",
      meet: "3:39 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Found on PDF Row 155
    {
      day: "Sunday",
      time: "9:42 AM",
      teamId: "j3revenge",
      meet: "9:06 AM",
      panel: "Hall A",
    },

    // J2 Twilight (Row 215)
    {
      day: "Sunday",
      time: "2:35 PM",
      teamId: "j2twilight",
      meet: "1:59 PM",
      panel: "Hall B",
    },
  ],
};
